import { Outlet } from 'react-router-dom'
import React from 'react'

const AccountSetting = () => {
  return (
    <Outlet/>
  )
}

export default AccountSetting